module.exports = __webpack_public_path__ + "img/SKLB-Citas.bd5de750.png";